import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-92cc6e8a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "contnet-warp" }
const _hoisted_2 = { class: "contnet-warp-icon" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "dashed" }, null, -1))
const _hoisted_4 = { class: "base-svg" }
const _hoisted_5 = { class: "contnet-warp-icon-pint" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "contnet-warp-icon-pint-item-r" }, [
  /*#__PURE__*/_createElementVNode("div", {
    id: "lines",
    class: "contnet-warp-icon-pint-line"
  }),
  /*#__PURE__*/_createElementVNode("div", { class: "contnet-warp-icon-pint-dot" })
], -1))
const _hoisted_7 = [
  _hoisted_6
]
const _hoisted_8 = { class: "content-warp-text" }
const _hoisted_9 = { class: "content-warp-text-item-r" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "white" }, null, -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "bg" }, null, -1))
const _hoisted_12 = { class: "inner" }
const _hoisted_13 = { class: "content-name" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "block-color" }, null, -1))

import { ref, onMounted } from 'vue';
import {
  selfAdaption,
  pcModulePatientSex6,
  useDataAssembly
  // sequence
} from './hooks';
import { svg6, baseSvg } from './svg-components/index';

export default /*#__PURE__*/_defineComponent({
  __name: 'pc-module-survey-2-6',
  props: {
    tableHeaderList: {},
    tableDataList: {}
  },
  setup(__props: any) {

const props = __props;
let data = useDataAssembly(props.tableHeaderList, props.tableDataList);
const TaskRef = ref<HTMLDivElement>();
const ContentRef = ref<HTMLDivElement>();
const scale = ref(1);
onMounted(async () => {
  await selfAdaption(TaskRef, ContentRef, scale);
  pcModulePatientSex6(TaskRef.value);
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "patient-sex",
    ref_key: "TaskRef",
    ref: TaskRef,
    style: _normalizeStyle({
      transform: `scale(${scale.value})`,
      transformOrigin: '0 0'
    })
  }, [
    _createElementVNode("div", {
      class: "contnet",
      ref_key: "ContentRef",
      ref: ContentRef
    }, [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _hoisted_3,
          _createVNode(_unref(svg6)),
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", null, [
              _createVNode(_unref(baseSvg))
            ])
          ]),
          _createElementVNode("div", _hoisted_5, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(data).tipData, (item, index) => {
              return (_openBlock(), _createElementBlock("div", {
                id: "pints",
                class: "contnet-warp-icon-pint-item",
                key: index,
                style: _normalizeStyle({ '--color': `var(--theme-color-${index + 1},#000)` })
              }, _hoisted_7, 4))
            }), 128))
          ])
        ]),
        _createElementVNode("div", _hoisted_8, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(data).tipData, (item, index) => {
            return (_openBlock(), _createElementBlock("div", {
              id: "texts",
              class: "content-warp-text-item",
              key: index,
              style: _normalizeStyle({ '--color': `var(--theme-color-${index + 1},#000)` })
            }, [
              _createElementVNode("div", _hoisted_9, [
                _hoisted_10,
                _hoisted_11,
                _createElementVNode("div", _hoisted_12, [
                  _createElementVNode("div", null, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item, (citem, cindex) => {
                      return (_openBlock(), _createElementBlock("div", { key: cindex }, _toDisplayString(citem.label) + "：" + _toDisplayString(citem.value), 1))
                    }), 128))
                  ])
                ])
              ])
            ], 4))
          }), 128))
        ])
      ]),
      _createElementVNode("div", _hoisted_13, [
        _createElementVNode("div", null, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(data).projectName, (item, index) => {
            return (_openBlock(), _createElementBlock("div", {
              style: _normalizeStyle({ '--color': `var(--theme-color-${index + 1},#000)` }),
              key: index
            }, [
              _hoisted_14,
              _createElementVNode("div", null, _toDisplayString(item.value), 1)
            ], 4))
          }), 128))
        ])
      ])
    ], 512)
  ], 4))
}
}

})